import React from 'react';
import { useSearchParams } from 'react-router-dom';
import ProposalWizardPage from '../pages/ProposalWizardPage';
import ServiceProposalWizardPage from '../pages/ServiceProposalWizardPage';
import NgoGrantProposalWizardPage from '../pages/NgoGrantProposalWizardPage';
import BusinessPlanWizardPage from '../pages/BusinessPlanWizardPage';

/**
 * Routes /documents/business-proposal/generate to the correct wizard
 * based on the ?category= query param from template selection.
 */
export default function ProposalGenerateRoute() {
  const [searchParams] = useSearchParams();
  const category = searchParams.get('category') || 'business_grant_proposal';

  if (category === 'service_proposal') {
    return <ServiceProposalWizardPage />;
  }
  if (category === 'ngo_grant_proposal') {
    return <NgoGrantProposalWizardPage />;
  }
  if (category === 'business_plan_funding') {
    return <BusinessPlanWizardPage />;
  }
  return <ProposalWizardPage />;
}
